export const ElementsConfig = {


    forenameTextConfig: {
        type: 'textBox',
        value: '',
        name: 'forename',
        label: 'First name',
        readonly: false,
        maxlength: 18,
        controlName: 'forename',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter a first name',
        errorMessageInvalid: 'Please enter a valid first name',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    middleNameTextConfig: {
        type: 'textBox',
        value: '',
        name: 'middleName',
        label: 'Second name',
        readonly: false,
        maxlength: 18,
        controlName: 'middleName',
        borderRequired: false,
        required: false,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter a second name',
        errorMessageInvalid: 'Please enter a valid second name',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    surnameTextConfig: {
        type: 'textBox',
        value: '',
        name: 'surname',
        label: 'Surname',
        readonly: false,
        maxlength: 30,
        controlName: 'surname',
        borderRequired: false,
        required: false,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter a surname',
        errorMessageInvalid: 'Please enter a valid surname',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    thirdNameTextConfig: {
        type: 'textBox',
        value: '',
        name: 'thirdName',
        label: 'Third name',
        readonly: false,
        maxlength: 18,
        controlName: 'thirdName',
        borderRequired: false,
        required: false,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter a third name',
        errorMessageInvalid: 'Please enter a valid third name',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    ninoConfig: {
        type: 'textBox',
        value: '',
        name: 'nino',
        label: 'National Insurance number',
        readonly: false,
        maxlength: 9,
        controlName: 'nino',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter your National insurance number',
        errorMessageInvalid: 'Please enter a valid National insurance number',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    emailTextConfig: {
        type: 'textBox',
        value: '',
        name: 'emailAddress',
        label: 'Email address',
        content: 'We\'ll use this to send you a registration link, which you can use to retrieve your quotes and apply online.',
        readonly: false,
        controlName: 'emailAddress',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter an e-mail address',
        invalidErrorMessage: 'Please enter a valid e-mail address',


        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    confirmEmailTextConfig: {
        type: 'textBox',
        value: '',
        name: 'confirmEmailAddress',
        label: 'Email address confirmation',
        readonly: false,
        controlName: 'confirmEmailAddress',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter a confirmation e-mail address',
        invalidErrorMessage: 'Please re-enter your confirmation e-mail address as it does not match',
        misMatchErrorMessage: 'Please re-enter your confirmation e-mail address as it does not match',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    mobilePhoneConfig: {
        type: 'textBox',
        value: '',
        name: 'mobilePhone',
        label: 'Mobile phone',
        readonly: false,
        controlName: 'mobilePhone',
        borderRequired: false,
        required: false,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter your mobile phone number if you wish to be kept updated by text message',
        invalidErrorMessage: 'Please use numbers. If you using an international format, use + and the dial-in code at the beginning.',
        maxlength: 24,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    contactNumberConfig: {
        type: 'textBox',
        value: '',
        name: 'mobilePhone',
        label: 'Contact number',
        readonly: false,
        controlName: 'mobilePhone',
        borderRequired: false,
        required: false,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter a contact number',
        invalidErrorMessage: 'Please use only numbers',
        maxlength: 16,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    homePhoneConfig: {
        type: 'textBox',
        value: '',
        name: 'homePhone',
        label: 'Home telephone',
        readonly: false,
        controlName: 'homePhone',
        borderRequired: false,
        required: false,
        maxlength: 24,
        placeHolder: 'Please enter',
        errorMessage: 'Please enter your mobile phone number if you wish to be kept updated by text message',

        invalidErrorMessage: 'Please use numbers. If you using an international format, use + and the dial-in code at the beginning.',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    addressLine1Config: {
        type: 'textBox',
        value: '',
        name: 'addressline1',
        label: 'Address line 1',
        readonly: false,
        maxlength: '35',
        controlName: 'addressline1',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',


        errorMessage: 'Please enter an address line 1 value',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    addressLine2Config: {
        type: 'textBox',
        value: '',
        name: 'addressline2',
        label: 'Address line 2',
        readonly: false,
		maxlength: '35',
        controlName: 'addressline2',
        borderRequired: false,
        required: false,
        placeHolder: 'Please enter',


        errorMessage: 'Please enter an address line 2 value',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    addressLine3Config: {
        type: 'textBox',
        value: '',
        name: 'addressline3',
        label: 'Address line 3',
        readonly: false,
        controlName: 'addressline3',
		maxlength: '35',
        borderRequired: false,
        required: false,
        placeHolder: 'Please enter',



        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    addressLine4Config: {
        type: 'textBox',
        value: '',
        name: 'addressline4',
        label: 'Address line 4',
        readonly: false,
        controlName: 'addressline4',
		maxlength: '35',
        borderRequired: false,
        required: false,
        placeHolder: 'Please enter',



        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    personalDetailDOBInformation: {
        label: '',
        // tslint:disable-next-line:max-line-length
        content: 'For us to give you a valid quote, you\'ll need to be in the right age bracket to take an annuity within the next 35 days. Our minimum age is 54 years and 9 months and our maximum is 120 years. If you are in a special situation, please call us.',
        disabledInfoIconTextVisibility: false
    },
    postCodeInformationConfig: {
        label: '',
        // tslint:disable-next-line:max-line-length
        content: 'This helps us check whether we can give you a quote. If you haven\'t got a UK address please set this field to No',
        disabledInfoIconTextVisibility: false
    },
    postCodetextConfig: {
        label: '',
        // tslint:disable-next-line:max-line-length
        content: 'Postcode of customer\'s current permanent UK residential address',
        disabledInfoIconTextVisibility: false
    },
    beneficiaryFirstNameToolTipInfoConfig: {
        label: '',
        // tslint:disable-next-line:max-line-length
        content: 'Your first name and surname should not contain any numbers or punctuation apart from ` and -',
        disabledInfoIconTextVisibility: false
    },

    firstNameToolTipInfoConfig: {
        label: '',
        // tslint:disable-next-line:max-line-length
        content: 'Your first, second, third name and surname should not contain any numbers or punctuation apart from ` and -',
        disabledInfoIconTextVisibility: false
    },
    accountNumberToolTipInfoConfig: {
        label: '',
        // tslint:disable-next-line:max-line-length
        content: 'Must be between 6 and 8 digits long',
        disabledInfoIconTextVisibility: false
    },
    rollNumberToolTipInfoConfig: {
        label: '',
        // tslint:disable-next-line:max-line-length
        content: 'You can find it on your card, statement or passbook',
        disabledInfoIconTextVisibility: false

    },

    genderConfig: {
        type: 'dropdown',
        options: [
            { value: 'Male', code: 'M' },
            { value: 'Female', code: 'F' }
        ],
        defaultValue: null,
        name: 'gender',
        label: 'Gender',
        errorMessage: 'Please select a gender',
        readonly: false,
        controlName: 'gender',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    fundProviderConfig: {
        type: 'dropdown',
        options: [
            // { value: 'Aegon', code: 'A' },
            // { value: 'Legal & General', code: 'L' },
            { value: 'Aegon', code: 'H', controlName: 'aegon' },
           /* { value: 'DDP1', code: 'M', controlName: 'ddp1' },
            { value: 'DDP2', code: 'N', controlName: 'ddp2' },
            { value: 'DDP3', code: 'O', controlName: 'ddp3' },
            { value: 'DDP4', code: 'P', controlName: 'ddp4' },*/
            { value: 'Legal & General', code: 'I', controlName: 'internal' },
            { value: 'Prudential', code: 'K', controlName: 'prudential' },
            { value: 'PensionBee', code: 'L', controlName: 'pensionBee' },
            { value: 'Aon', code: 'M', controlName: 'aon' },
            { value: 'ReAssure', code: 'J', controlName: 'reAssure' }, 
            { value: 'Sun Life Financial of Canada', code: 'F', controlName: 'sunLife' },
            { value: 'Phoenix Life', code: 'O', controlName: 'phoenixLife' },
            { value: 'More than one of the above', code: 'D', controlName: 'many' },
            { value: 'None of the above', code: 'B', controlName: 'external' }
        ],
        defaultValue: null,
        name: 'fundProvider',
        label: 'Which pension provider referred you to us for this quote? ',
        // errorMessage: 'Please make a selection',
        // tslint:disable-next-line:max-line-length
        prudentialInvalid: 'We are unable to give you a quote online but we can over the phone. Please call customer services on 0800 048 2446 and quote your reference number which you can find at the top of the screen.',
        externalInvalid: 'We are unable to give you a quote as you do not live in the UK.',
        // tslint:disable-next-line:max-line-length
        manyInvalid: 'As you have been introduced by more than one of our partners, we need to give you individual quotes for each of your pension funds to ensure you get the best deal. You can do these online by selecting each partner individually or you can call customer services on 0800 048 2446 and quote your reference number which you can find at the top of the screen.',
        // label: 'Who introduced?',
        errorMessage: 'Please make a selection',
        readonly: false,
        controlName: 'fundProvider',
        borderRequired: false,
        required: true,
        // tslint:disable-next-line:max-line-length
        content: 'We need you to select which pension provider contacted you to refer you here to get a quote. This so we can make sure our quote accurately matches your circumstances. If you weren’t contacted or your provider isn’t shown please select other.',
    },
    maritalStatusConfig: {
        type: 'dropdown',
        options: [
            { value: 'Single', code: 'S' },
            { value: 'Married', code: 'M' },
            { value: 'Registered civil partnership', code: 'CP' },
            { value: 'Cohabiting', code: 'CH' },
            { value: 'Divorced', code: 'D' },
            { value: 'Separated', code: 'SE' },
            { value: 'Widowed', code: 'W' }
        ],
        defaultValue: null,
        name: 'maritalStatus',
        label: 'Marital status',
        errorMessage: 'Please select a marital status',
        readonly: false,
        controlName: 'maritalStatus',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },

    titleConfig: {
        type: 'dropdown',
        options: [
            { value: 'Mr', code: 'Mr' },
            { value: 'Miss', code: 'Miss' },
            { value: 'Mrs', code: 'Mrs' },
            { value: 'Ms', code: 'Ms' },
            { value: 'Mx', code: 'Mx' },
            { value: 'Doctor', code: 'Doctor' },
            { value: 'Other', code: 'Other' }
        ],
        defaultValue: null,
        name: 'title',
        label: 'Title',
        errorMessage: 'Please select a title',
        readonly: false,
        controlName: 'title',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    radioButtonIsUKAddressConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: '',
        questionType: 'Static',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'Yes',
                code: 'Y'
            },
            {
                label: 'No',
                code: 'N'
            }
        ],
        infoIconFlag: true,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'This helps us check whether we can give you a quote. If you haven\'t got a UK address please set this field to No.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: false
    },
    radioButtonIsDoctorUKAddressConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'Is your doctor based in the UK ?',
        questionType: 'Static',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'Yes',
                code: 'Y'
            },
            {
                label: 'No',
                code: 'N'
            }
        ],
        infoIconFlag: false,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'This helps us check whether we can give you a quote. If you haven\'t got a UK address please set this field to No.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: false
    },
    radioButtonIsBeneficiaryUKAddressConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'Does this beneficiary live in the UK?',
        questionType: 'Static',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'Yes',
                code: 'Y'
            },
            {
                label: 'No',
                code: 'N'
            }
        ],
        infoIconFlag: false,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'This helps us check whether we can give you a quote. If you haven\'t got a UK address please set this field to No.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: false
    },
    postCodeConfig: {
        type: 'textBox',
        defaultValue: '',
        name: 'postcode',
        labelText: 'Postcode',
        controlName: 'postcode',
        readonly: false,
        errorMessage: 'Please enter a postcode',
        errorMessageInvalid: 'Please enter a valid UK postcode',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    overseasPostCodeConfig: {
        type: 'textBox',
        defaultValue: '',
        name: 'postcode',
        labelText: 'Postcode',
        controlName: 'postcode',
        readonly: false,
        errorMessage: 'Please enter a postcode',
        errorMessageInvalid: 'Please enter a valid postcode',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    dobConfig: {
        type: 'textBox',
        value: '',
        name: 'dateOfBirth',
        label: 'Date of birth',
        readonly: false,
        controlName: 'dateOfBirth',
        controlWidth: 150,
        borderRequired: false,
        required: true,
        placeHolder: 'DD / MM / YYYY',
        errorMessage: 'Please enter a date of birth',
        errorMessageInvalidDate: 'Please enter a valid date',
        errorMessageInvalidFormat: 'Please enter a date in format DD/MM/YYYY',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    relationshipConfig: {
        type: 'dropdown',
        options: [
            { value: 'Spouse', code: 'S' },
            { value: 'Registered civil partner', code: 'R' },
            { value: 'Financial dependant', code: 'F' }
        ],
        defaultValue: null,
        name: 'relationship',
        label: 'Relationship to you',
        errorMessage: 'Please select a relationship to you',
        readonly: false,
        controlName: 'relationship',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    loginbuttonConfig: {
        type: 'button',
        values: '',
        name: 'next',
        label: 'Go to Login',
        readonly: false,
        controlName: 'next',
        borderRequired: false,
        required: true,
        classType: 'btn-cta',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    buttonConfig: {
        type: 'button',
        values: '',
        name: 'next',
        label: 'Next',
        readonly: false,
        controlName: 'next',
        borderRequired: false,
        required: true,
        classType: 'btn-cta',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    buttonConfigSummary: {
        type: 'button',
        values: '',
        name: 'next',
        label: 'Next',
        readonly: false,
        controlName: 'next',
        borderRequired: false,
        required: true,
        classType: 'btn-cta',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    regsiterbuttonConfig: {
        type: 'button',
        values: '',
        name: 'register_now',
        label: 'Register now',
        readonly: false,
        controlName: 'register_now',
        borderRequired: false,
        required: true,
        classType: 'btn-cta',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    dependantDetailDob: {
        type: 'textBox',
        value: '',
        name: 'dateOfBirth',
        label: 'Date of birth',
        readonly: false,
        controlName: 'dateOfBirth',
        controlWidth: 150,
        borderRequired: false,
        required: true,
        placeHolder: 'DD / MM / YYYY',
        errorMessage: 'Please enter a date of birth',
        errorMessageInvalidDate: 'Please enter a valid date',
        errorMessageInvalidFormat: 'Please enter a date in format DD/MM/YYYY',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    depandantDetailGenderConfig: {
        type: 'dropdown',
        options: [
            { value: 'Male', code: 'M' },
            { value: 'Female', code: 'F' }
        ],
        defaultValue: null,
        name: 'gender',
        label: 'Gender',
        errorMessage: 'Please select a gender',
        readonly: false,
        controlName: 'gender',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    sourcesListCvt: [
        { value: 'Legal & General', code: 'Int.', controlName: 'internal', fundProvider: 'I' },
        { value: 'Aegon', code: 'CDF', controlName: 'aegon', productCodeValidationRule: /^[0-9]{2}[t]?$/i, fundProvider: 'H' },
        { value: 'Sun Life Financial of Canada', code: 'CDF', controlName: 'sunLife', productCodeValidationRule: /^[0]$/i, fundProvider: 'F' },
        { value: 'Phoenix Life', code: 'CDF', controlName: 'phoenixLife', productCodeValidationRule: /^[0]$/i, fundProvider: 'O' },
        { value: 'ReAssure', code: 'CDF', controlName: 'reAssure', fundProvider: 'J' }, 
        { value: 'Other', code: 'Ext', controlName: 'external', fundProvider: 'B' },
        { value: 'Prudential', code: 'K', controlName: 'prudential', fundProvider: 'K'}
    ],
    fundAttributes: [
        'fundValue', 'transferType', 'productCode'
    ],
    fundValueConfig: {
        type: 'currency',
        value: '',
        name: 'cncyfundValue',
        readonly: false,
        controlName: 'cncyfundValue',
        required: true,
        placeHolder: '',
        errorMessage: 'Please make a selection',
        minValue: '0.00',
        maxValue: '99999999.99',
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'If you choose yearly income then we will calculate your maturity value based on the money that is left over. If you choose maturity value, then we will calculate this and the remaining money will be used to calculate your income.',
            disabledInfoIconTextVisibility: false
        },
        infoIconFlag: false
    },
    productCodeConfig: {
        type: 'textBox',
        value: '',
        name: 'productCode',
        label: 'Product Code',
        readonly: false,
        controlName: 'productCode',
        borderRequired: false,
        required: true,
        validationMsg: 'Please enter an amount',
        placeHolder: 'Please enter',
        addAnothercode: 'Add another code',
        errorProductCode: 'Please enter the product code',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        },
        validationRule: /^[0-9]{2}[a-z]$/i
    },
    dependantDetailTitleInformation: {
        label: '',
        // tslint:disable-next-line:max-line-length
        content: 'Our Pension Annuity lets you nominate your surviving partner for an income for life, from your pension savings. This will be your spouse, civil partner or another financially-dependent partner. If this excludes someone you need to take care of in the event of your death, you may choose a different kind of protection for them, in a few moments.',
        disabledInfoIconTextVisibility: false
    },
    productChoice: {
        products: [
            {
                productName: 'Pension Annuity',
                productCode: 'C',
                controlName: 'chkPensionAnnuity',
                selected: false,
                imageName: 'pensionAnnuity-logo.png'
            },
            {
                productName: 'Fixed Term Retirement Plan',
                productCode: 'H',
                controlName: 'chkFixedTerm',
                selected: false,
                imageName: 'fixedTermRetiremen-logo.png'
            },
            {
                productName: 'Cash-Out Retirement Plan',
                productCode: 'G',
                controlName: 'chkCashOut',
                selected: false,
                imageName: 'fixedTermRetiremen-logo.png'
            }
        ]
    },
    QuoteAffectingValues: {
        personalDetail: [
            'gender',
            'dateOfBirth',
            'maritalStatus',
            'postcode',
            'ukaddressIndicator'
        ],
        dependantDetail: [
            'gender',
            'dateOfBirth',
            'relationship'
        ]
    },
    radioButtonDependantConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'Would you like us to continue to pay your qualifying partner an income after you die, for the rest of their life?',
        questionType: 'Static',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'Yes',
                code: 'Y'
            },
            {
                label: 'No',
                code: 'N'
            }
        ],
        infoIconFlag: true,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'You should consider whether the plan you choose will provide adequate benefits for your loved ones in the event of your death.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: false
    },
    healthAndLifestyleConfig: {
        type: 'textBox',
        value: '',
        name: 'healthAndLifestyle',
        label: 'Integer',
        readonly: false,
        controlName: 'healthAndLifestyle',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        },
        tooltipInfo: {
            label: '',
            content: '',
            disabledInfoIconTextVisibility: false
        },
        validationRule: /^[0-9]{2}[a-z]$/i
    },
    dealPartnerInformation: {
        label: '',
        // tslint:disable-next-line:max-line-length
        content: 'We need you to select which pension provider referred you to us for a quote. This is so we can make sure our quote accurately matches your circumstances. If you weren’t referred please select \'None of the above\'. ',
        disabledInfoIconTextVisibility: false
    },
    diabetesConfig: {
        type: 'dropdown',
        options: [
            { value: '', code: '' },
            { value: '', code: '' }
        ],
        defaultValue: null,
        name: 'diabetes',
        label: 'Is your Diabetes?',
        errorMessage: '- Please select -',
        readonly: false,
        controlName: 'diabetes',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    medicalConditions: {
        list: [
            {
                mcName: 'High Blood Pressure',
                mcCode: 'HBP',
                controlName: 'chkHighBloodPressure',
                selected: false
            },
            {
                mcName: 'High Cholesterol',
                mcCode: 'HC',
                controlName: 'chkHighCholesterol',
                selected: false
            },
            {
                mcName: 'Diabetes',
                mcCode: 'D',
                controlName: 'chkDiabetes',
                selected: false
            },
            {
                mcName: 'Respiratory Disease',
                mcCode: 'RD',
                controlName: 'chkRespiratoryDisease',
                selected: false
            },
            {
                mcName: 'Heart Disease',
                mcCode: 'HD',
                controlName: 'chkHeartDisease',
                selected: false
            },
            {
                mcName: 'Cancer',
                mcCode: 'C',
                controlName: 'chkCancer',
                selected: false
            },
            {
                mcName: 'Stroke',
                mcCode: 'H',
                controlName: 'chkStroke',
                selected: false
            },
            {
                mcName: 'Neurological Disease',
                mcCode: 'ND',
                controlName: 'chkNeurologicalDisease',
                selected: false
            },
            {
                mcName: 'Other',
                mcCode: 'O',
                controlName: 'chkOther',
                selected: false
            }
        ]
    },



    sortCodeConfigVal: {
        type: 'text',
        value: '',
        name: 'sortcode',
        label: 'Sort code',
        readonly: false,
        controlName: 'sortcode',
        controlWidth: 150,
        maxlength: 8,
        borderRequired: false,
        required: true,
        placeHolder: '00-00-00',
        errorMessage: 'Please enter a valid sort code',
        errorMessageInvalid: 'Please enter a valid sort code',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },

    accountNumberConfigVal: {
        type: 'text',
        value: '',
        name: 'accountNumber',
        label: 'Account number',
        readonly: false,
        controlName: 'accountNumber',
        controlWidth: 150,
        borderRequired: false,
        required: true,
        maxlength: 8,
        placeHolder: '00000000',
        errorMessage: 'Please enter a valid account number',
        errorMessageInvalid: 'Please enter a valid account number',
        errorMatch: 'The account number and sort code is not a valid combination. Please check and try again.',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    bankNameConfigVal: {
        type: 'text',
        value: '',
        name: 'bankName',
        label: 'Bank name',
        readonly: false,
        controlName: 'bankName',
        controlWidth: 150,
        borderRequired: false,
        required: true,
        maxlength: 50,
        placeHolder: '',
        errorMessage: 'Please enter the name of your bank',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    rollNumberConfigVal: {
        type: 'text',
        value: '',
        name: 'rollNumber',
        label: 'Roll number',
        readonly: false,
        controlName: 'rollNumber',
        controlWidth: 150,
		maxlength: 20,
        borderRequired: false,
        required: false,
        placeHolder: '',
        errorMessage: 'Please enter a valid roll number',
        errorMessageInvalid: 'Please enter a valid roll number',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    accountHolderConfigVal: {
        type: 'text',
        value: '',
        name: 'accountHolder',
        label: 'Account holder(s)',
        readonly: false,
        controlName: 'accountHolder',
        controlWidth: 150,
		maxlength: 18,
        borderRequired: false,
        required: true,
        placeHolder: '',
        errorMessage: 'Please enter an account name',
        errorMessageInvalid: 'Please enter a valid account name',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    countryConfig: {
        type: 'dropdown',
        options: [],
        defaultValue: null,
        name: 'country',
        label: 'Country',
        errorMessage: 'Please select a Country',
        readonly: false,
        controlName: 'country',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    dependantTitleConfig: {
        type: 'dropdown',
        options: [
            { value: 'Mr', code: 'Mr' },
            { value: 'Miss', code: 'Miss' },
            { value: 'Mrs', code: 'Mrs' },
            { value: 'Ms', code: 'Ms' },
            { value: 'Doctor', code: 'Doctor' },
            { value: 'Other', code: 'Other' }
        ],
        defaultValue: null,
        name: 'title',
        label: 'Title',
        errorMessage: 'Please select a title',
        readonly: false,
        controlName: 'title',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    goBacktoQuoteBtnConfig: {
        type: 'button',
        values: '',
        name: 'Backtomy_quotes',
        label: 'Back to my quotes',
        readonly: false,
        controlName: 'Backtomy_quotes',
        borderRequired: false,
        required: true,
        classType: 'btn-cta',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    pensionProviderConfig: {
        type: 'textbox',
        value: '',
        name: 'providerAddress',
        label: 'Pension provider',
        readonly: false,
        maxlength: 90,
        controlName: 'providerAddress',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',
        errorMessage: 'Please make a selection',
        invalidErrorMessage: 'Please enter only the following characters:  letters, numbers, @&<>,=/',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    radioButtonFundtransferType: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'Is this the full value of your pension?',
        questionType: 'Static',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'Full',
                code: 'F'
            },
            {
                label: 'Partial',
                code: 'P'
            }
        ],
        infoIconFlag: false,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'This helps us check whether we can give you a quote. If you haven\'t got a UK address please set this field to No.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        inValidTransferType: 'As your fund is in drawdown, full fund must be provided',
        disabled: false
    },
    radioButtonFunddrawdown: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'Is your plan in drawdown? ',
        questionType: 'Static',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'Yes',
                code: 'Y'
            },
            {
                label: 'No',
                code: 'N'
            }
        ],
        infoIconFlag: true,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'Drawdown is a pension product that lets you access your pension savings whenever you need to, while reinvesting your remaining funds in a way that\'s specially designed to provide an ongoing retirement income.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: false
    },
    radioButtontaxfreeCashConfig: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'of which tax-free cash total is?',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'None',
                code: 'N',
                disable: true
            },
            {
                label: '%',
                code: 'P',
                disable: true
            },
            {
                label: '£',
                code: 'C',
                disable: true
            }
        ],
        infoIconFlag: true,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'You can get the same income amount for life, but inflation will chip away at the spending power of that income. You could choose instead to make it increase each year. The increase can be at a fixed rate, such as 2% every year, or in step with inflation, measured by the UK&#39;s Retail Price Index (RPI). If you choose to increase your income each year, your income will start at a lower level.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        invalidTaxfree: 'Because your fund is in drawdown, tax-free cash is not possible',
        disabled: false
    },
    sliderTaxfreeLumpsumConfig: {
        // tslint:disable-next-line:max-line-length
        sliderTitle: 'How much would you like us to pay you as tax-free cash?',
        sliderTitleVisible: false,
        sliderType: 'Price',
        sliderTypeVisible: true,
        visible: false,
        infoIconFlag: false,
        minValue: 0,
        maxValue: 25,
        currentValue: 10,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'You can normally take up to 25% of your pension pot as a tax-free cash sum. Taking money from your pension pot will reduce what’s left to buy an income.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        invalidLTAMinMsg: 'The minimum pension fund required after tax-free cash is £[LTAMin]',
        stepsArray: [],
        unselectedByDefault: true,
        fundAmount: 0
    },
    taxfreeValueConfig: {
        type: 'currency',
        value: '',
        name: 'cncyfundValueTaxfree',
        readonly: false,
        controlName: 'cncyfundValueTaxfree',
        required: true,
        placeHolder: '',
        errorMessage: 'Please make a selection',
        invalidTaxfreeMessage: 'Selected tax-free cash exceeds 25% of [dealpartner] policy fund',
        invalidLTAMinMsg: 'The minimum pension fund required after tax-free cash is £[LTAMin]',
        minValue: '0.00',
        maxValue: '99999999.99',
        infoIconData: {
            // tslint:disable-next-line:max-line-length
            content: 'This is the amount you take as an up-front lump sum, with no tax to pay. The maximum is normally 25% of the pot. Check with your existing savings scheme to make sure you\'re taking it out at the right point. Taking money from your fund will reduce what\'s left to buy an income for your retirement. We strongly recommend you seek financial guidance before making these decisions.',
            disabledInfoIconTextVisibility: false
        },
        infoIconFlag: false,
        title: true,
        titleValue: '0',
        visible: false,
    },
    taxfreeValueConfigExt: {
        type: 'currency',
        value: '',
        name: 'fundValueTaxfreeExt',
        readonly: false,
        controlName: 'fundValueTaxfreeExt',
        required: true,
        placeHolder: '',
        errorMessage: 'Please make a selection',
        invalidTaxfreeMessage: 'Selected tax-free cash exceeds 25% of [dealpartner] policy fund',
        invalidLTAMinMsg: 'The minimum pension fund required after tax-free cash is £[LTAMin]',
        minValue: '0.00',
        maxValue: '99999999.99',
        infoIconData: {
            // tslint:disable-next-line:max-line-length
            content: 'This is the amount you take as an up-front lump sum, with no tax to pay. The maximum is normally 25% of the pot. Check with your existing savings scheme to make sure you\'re taking it out at the right point. Taking money from your fund will reduce what\'s left to buy an income for your retirement. We strongly recommend you seek financial guidance before making these decisions.',
            disabledInfoIconTextVisibility: false
        },
        infoIconFlag: false,
        title: true,
        titleValue: '0'
    },
    extFundValueConfig: {
        type: 'currency',
        value: '',
        name: 'fundValueExt',
        readonly: false,
        controlName: 'fundValueExt',
        required: true,
        placeHolder: '',
        errorMessage: 'Please make a selection',
        minValue: '0.00',
        maxValue: '99999999.99',
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'If you choose yearly income then we will calculate your maturity value based on the money that is left over. If you choose maturity value, then we will calculate this and the remaining money will be used to calculate your income.',
            disabledInfoIconTextVisibility: false
        },
        infoIconFlag: false
    },
    extPensionProviderConfig: {
        type: 'textbox',
        value: '',
        name: 'providerAddress',
        label: 'Pension provider',
        readonly: false,
        maxlength: 70,
        controlName: 'providerAddress',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',
        errorMessage: 'Please make a selection',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    radioButtonFundtransferTypeExt: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'Is this the full value of your pension?',
        questionType: 'Static',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'Full',
                code: 'F'
            },
            {
                label: 'Partial',
                code: 'P'
            }
        ],
        infoIconFlag: false,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'This helps us check whether we can give you a quote. If you haven\'t got a UK address please set this field to No.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: false
    },
    radioButtonFunddrawdownExt: {
        // tslint:disable-next-line:max-line-length
        questionStatement: 'Is your plan in drawdown? ',
        questionType: 'Static',
        isSafetyQuestion: false,
        questionOptions: [
            {
                label: 'Yes',
                code: 'Y'
            },
            {
                label: 'No',
                code: 'N'
            }
        ],
        infoIconFlag: true,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'Drawdown is a pension product that lets you access your pension savings whenever you need to, while reinvesting your remaining funds in a way that\'s specially designed to provide an ongoing retirement income.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        disabled: false
    },
    providerAddressConfig: {
        type: 'textbox',
        value: '',
        name: 'providerAddress',
        label: 'Pension provider address',
        readonly: false,
        maxlength: 70,
        controlName: 'providerAddress',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',
        errorMessage: 'Please make a selection',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    providerAddressExtConfig: {
        type: 'textbox',
        value: '',
        name: 'providerAddressExt',
        label: 'Pension provider address',
        readonly: false,
        maxlength: 70,
        controlName: 'providerAddressExt',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',
        errorMessage: 'Please make a selection',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    planNumberConfig: {
        type: 'textbox',
        value: '',
        name: 'planNumber',
        label: 'Plan Number',
        readonly: false,
        maxlength: 16,
        controlName: 'planNumber',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',
        errorMessage: 'Please make a selection',
        invalidErrorMessage: 'Please enter only the following characters: letters, numbers and /',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    planNumberExtConfig: {
        type: 'textbox',
        value: '',
        name: 'planNumberExt',
        label: 'Plan Number',
        readonly: false,
        maxlength: 16,
        controlName: 'planNumberExt',
        borderRequired: false,
        required: true,
        placeHolder: 'Please enter',
        errorMessage: 'Please make a selection',
        invalidErrorMessage: 'Please enter only the following characters: letters, numbers and /',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    sliderTaxfreeLumpsumExtConfig: {
        // tslint:disable-next-line:max-line-length
        sliderTitle: 'How much would you like us to pay you as tax-free cash?',
        sliderTitleVisible: false,
        sliderType: 'Price',
        sliderTypeVisible: true,
        infoIconFlag: false,
        minValue: 0,
        maxValue: 25,
        currentValue: 10,
        infoIconData: {
            label: '',
            // tslint:disable-next-line:max-line-length
            content: 'You can normally take up to 25% of your pension pot as a tax-free cash sum. Taking money from your pension pot will reduce what’s left to buy an income.',
            disabledInfoIconTextVisibility: false
        },
        validationMsg: 'Please make a selection',
        invalidLTAMinMsg: 'The minimum pension fund required after tax-free cash is £[LTAMin]',
        stepsArray: [],
        unselectedByDefault: true
    },
    pensionProviderDDLConfig: {
        type: 'dropdown',
        options: [],
        defaultValue: null,
        name: 'country',
        label: 'Country',
        errorMessage: 'Please select a provider',
        readonly: false,
        controlName: 'country',
        borderRequired: false,
        required: true,
        value: '',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    productCodeDDLConfig: {
        type: 'dropdown',
        options: [],
        defaultValue: null,
        name: 'productCode',
        label: 'productCode',
        description:`Please select the product code that relates to your plan number from the list below. These are the product codes you supplied earlier. If you have made a mistake please call us on the number above.`,
        errorMessage: 'Please select a product Code',
        readonly: false,
        controlName: 'productCode',
        borderRequired: false,
        required: true,
        value: '',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    buttonConfigPensionSaving: {
        type: 'button',
        values: '',
        name: 'next',
        label: 'Next',
        readonly: false,
        controlName: 'next',
        borderRequired: false,
        required: true,
        classType: 'btn-cta',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    buttonConfigProductApplication: {
        type: 'button',
        values: '',
        name: 'next',
        label: 'Next',
        readonly: false,
        controlName: 'next',
        borderRequired: false,
        required: true,
        classType: 'btn-cta',
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    protectionTypeConfig: {
        type: 'dropdown',
        options: [
            { value: 'Primary', code: 'P' },
            { value: 'Enhanced', code: 'E' },
            { value: 'Fixed Protection', code: 'F' }
        ],
        defaultValue: null,
        name: 'ltaProtectionType',
        label: 'What protection have you been given?',
        errorMessage: 'Please tell us the type of protection you have',
        readonly: false,
        controlName: 'ltaProtectionType',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    },
    lsaProtectionTypeConfig: {
        type: 'dropdown',
        options: [
            { code: 'B', value: 'Enhanced Protection' },
            { code: 'A', value: 'Primary Protection' },
            { code: 'D', value: 'Fixed Protection 2012' },
            { code: 'F', value: 'Fixed Protection 2014' },
            { code: 'I', value: 'Fixed Protection 2016' },
            { code: 'E', value: 'Individual Protection 2014' },
            { code: 'H', value: 'Individual Protection 2016' }
        ],
        defaultValue: null,
        name: 'protectionType',
        label: 'What protection have you been given?',
        errorMessage: 'Please tell us the type of protection you have.',
        readonly: false,
        controlName: 'protectionType',
        borderRequired: false,
        required: true,
        keyCol: {
            md: 12,
            sm: 12,
            xs: 12
        },
        valCol: {
            md: 10,
            sm: 12,
            xs: 12
        }
    }
};
